import BaseEntity from './BaseEntity';
import CoverageEntry from './CommitCodeCoverage/CoverageEntry';
import Digest from './Digest';
export default class CommitCodeCoverage extends BaseEntity {
    constructor(codeCoverage) {
        super();
        this.changedLines = null;
        this.changedLinesDiff = null;
        this.digestDiff = null;
        this.entries = [];
        this.files = {};
        this.digest = new Digest(this.parseProperty(codeCoverage, 'digest'));
        if ('changedLines' in codeCoverage && typeof codeCoverage.changedLines !== 'undefined') {
            this.changedLines = this.parseProperty(codeCoverage, 'changedLines');
        }
        if ('changedLinesDiff' in codeCoverage && typeof codeCoverage.changedLinesDiff !== 'undefined') {
            this.changedLinesDiff = this.parseProperty(codeCoverage, 'changedLinesDiff');
        }
        if ('digestDiff' in codeCoverage && codeCoverage.digestDiff) {
            this.digestDiff = new Digest(this.parseProperty(codeCoverage, 'digestDiff'));
        }
        if ('entries' in codeCoverage) {
            this.entries = this.parseProperty(codeCoverage, 'entries').map(entry => new CoverageEntry(entry));
        }
        if ('files' in codeCoverage) {
            this.files = this.parseProperty(codeCoverage, 'files');
        }
    }
}
